import { TextField } from "@mui/material";
import Field from "components/Field";
import { DeliveryMethodSettingsDataType } from "types/common-types";
import { SkuDeliveryMethodSettingProps } from "../SkuDeliveryMethodSetting";

interface StandardSettingProps {
  item: SkuDeliveryMethodSettingProps;
}

const StandardSetting = ({ item }: StandardSettingProps) => {
  return (
    <Field
      name={`settingValues[${item.fieldIndex}].value`}
      required
      isHttpUrl={item.dataTypeName === DeliveryMethodSettingsDataType.Url}
    >
      {({ input, meta }) => (
        <TextField
          required
          variant="standard"
          fullWidth
          label={item.name}
          type={
            item.dataTypeName === DeliveryMethodSettingsDataType.Integer
              ? "number"
              : undefined
          }
          error={meta.error && meta.submitFailed}
          helperText={meta.error && meta.submitFailed && meta.error}
          {...input}
          value={input.value?.trim() || ""}
        />
      )}
    </Field>
  );
};

export default StandardSetting;